var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { css } from 'styled-components';
import { pxToRemCssProperty, weightToNumber } from '@anwb/style-utilities';
import { FALLBACK_FONTS } from '@anwb/theme';
/**
 * Converts the style properties required for the Typography component
 * to a Styled Components css object.
 */
export const stylePropertiesToCss = (_a) => {
    var { colorHover, fontFamily, fontWeight, fontStyle, fontSize, lineHeight, letterSpacing, paragraphSpacing, textDecorationHover } = _a, extraStyles = __rest(_a, ["colorHover", "fontFamily", "fontWeight", "fontStyle", "fontSize", "lineHeight", "letterSpacing", "paragraphSpacing", "textDecorationHover"]);
    return css `
	${fontFamily && `font-family: ${[fontFamily, ...FALLBACK_FONTS].join(',')};`}
	${fontWeight && `font-weight: ${weightToNumber(fontWeight, fontFamily)};`}
	${fontStyle && `font-style: ${fontStyle.toLowerCase()};`}
	${pxToRemCssProperty('font-size', fontSize)}
	${pxToRemCssProperty('line-height', lineHeight)}
	${pxToRemCssProperty('letter-spacing', letterSpacing)}
	${pxToRemCssProperty('margin-bottom', paragraphSpacing)}
	${extraStyles}

	:hover {
		color: ${colorHover};
		text-decoration: ${textDecorationHover};
	}
`;
};
//# sourceMappingURL=style-properties-to-css.js.map